import { render, staticRenderFns } from "./AddOrEditForm.vue?vue&type=template&id=32c9ca08&scoped=true"
import script from "./AddOrEditForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c9ca08",
  null
  
)

export default component.exports